import React from "react";
import { AccordionItem } from "react-accessible-accordion";

export default ({ children, teamId }) => {
  return <AccordionItem uuid={teamId}>{children}</AccordionItem>;
};
